import { Post } from '@wellesley/openapi'
import { useState } from 'react'

export const warningOptions = [
  'Nudity or Sexual Content',
  'Violence or Gore',
  'Self-Harm or Disturbing Theme',
  'Hate or Discriminatory Content',
  'Sensitive or Controversial Topic',
] as const

const useSensitiveControl = (feed?: Post) => {
  const [isSensitive, setIsSensitive] = useState(
    feed ? feed.settings.sensitive : false,
  )
  const [contentWarning, setContentWarning] = useState<string>(
    feed?.summary || '',
  )

  const toggleSensitive = () => {
    setIsSensitive(!isSensitive)
    const isCurrentlyEnabled = !!isSensitive
    isCurrentlyEnabled && setContentWarning('')
  }

  return {
    isSensitive,
    toggleSensitive,
    contentWarning,
    setContentWarning,
  }
}

export default useSensitiveControl
